import React, { Component } from 'react';
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
} from 'reactstrap';



import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { resetPassword } from '../../modules/agent';

const initialState = {
  credentials: {
    email: '',
  },
  errorMessage: '',
  success:""
};

class ResetPassword extends Component {

  state = {
    ...initialState,
  };

  componentWillMount(){
    var pathname = this.props.location.pathname;
    //  pathname = pathname.split('?');
    var clientId = pathname;
    console.log(clientId);

  }

  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  handleChange = (e) => {
   e.stopPropagation();
    e.preventDefault();
    const { name, value } = e.currentTarget;
    let newValue = value;

    const { credentials } = this.state;
    credentials[name] = newValue;
    this.setState(Object.assign(this.state, { credentials }));
  };

    validatePasswd = password => {
    var capital = /[A-Z]/g;
    var digits = /[0-9]/g;
    if (!password.match(capital) || !password.match(digits) || password.length<8)
      return false;
    return true;
  }

  handleSubmit = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const { credentials: {
    password,
    confirmPassword,
  }, errorMessage } = this.state;

  if (errorMessage) {
    this.setState({
      errorMessage: ''
    });
  }

  if (!this.validatePasswd(password)) {
    console.log('Your password must contain at least one capital letter and one number');
    this.setState({
      errorMessage: 'Your password must contain at least 8 characters, one capital letter and one number'
    });
    return;
  }

  if (confirmPassword !== password) {
    this.setState({
      errorMessage: 'Password and Confirm Password must match'
    });
    return;
  }

  const userpassword = {
    newPassword: password,
    token: this.getParameterByName('access_token', window.location.search)
  };
    const { resetPassword, history: { push } } = this.props;
    resetPassword(userpassword)
      .then(() => push('/'))
      .catch(e => {
    const error = e.response && e.response.data && e.response.data.error;
        this.setState(Object.assign(this.state, {
          errorMessage: (error && error.message) ||'Please provide a valid access token'
        }));
    });
  };

  render() {
    const { credentials, errorMessage, success } = this.state;
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row>
         {
        !!errorMessage && (
          <Col xs="12">
            <Alert color={this.state.success == 1 ? "success": "danger"} className="text-center">
              {errorMessage}
            </Alert>
          </Col>
          )
        }
       </Row>
          <Row className="justify-content-center">
            <Col md="10" lg="6">
              <CardGroup>
                <Card className="p-4">
                  <CardBody>
                    <Form onSubmit={this.handleSubmit}>
                      <h1>Enter New Password</h1>
                      <p className="text-muted">Request to change password</p>
                      <FormGroup>
                      <p>New Password</p>
                        <InputGroup className="mb-3">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i class="icon-lock"></i>
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            type="password"
                            placeholder="Password"
                            name="password"
                            value={credentials.password}
                            onChange={this.handleChange}
                            required
                          />
                        </InputGroup>
                      </FormGroup>
                      <FormGroup>
                      <p>Retype New Password</p>
                        <InputGroup className="mb-3">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i class="icon-lock"></i>
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            type="password"
                            placeholder="Password"
                            name="confirmPassword"
                            value={credentials.confirmPassword}
                            onChange={this.handleChange}
                            required
                          />
                        </InputGroup>
                      </FormGroup>
                      <Row>

                        <Col xs="12">
                          <Button block color="primary" type="submit" className="px-4">Change Password</Button>
                        </Col>
                      </Row>
                       


                    </Form>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  user: state.auth && state.auth.user,
});


const mapDispatchToProps = dispatch => bindActionCreators({
  resetPassword
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ResetPassword);


// WEBPACK FOOTER //
// ./src/containers/ResetPassword/ResetPassword.js